import React from 'react';
import {Popup, Explanation_text} from '../../../../../../../components';
import Typography from '@material-ui/core/Typography';

export default function Deal_delete_popup(props){
  return(
    <Popup always_open title='prospect_deal_delete_popup_title' accept_button='Delete' handleClose={props.handleClose} accept_button_click={props.onDelete} content={
      <div style={{width:'95vw', maxWidth:'600px', height:'200px', display:'flex', justifyContent:'center', alignItems:'center'}}>
        <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Typography style={{width:'100%', textAlign:'center'}}><Explanation_text inline text='prospect_deal_delete_popup_warning_text' placeholders={{name:props.deal.name}}/></Typography></div>
      </div>
    }/>
  )
}
